import { Controller } from "@hotwired/stimulus"

// Input Mode Controller - handles switching between typing, voice, and word ordering modes
export default class extends Controller {
  static targets = [
    "typingBtn",
    "voiceBtn",
    "wordOrderBtn",
    "typingMode",
    "voiceMode",
    "wordOrderMode",
    "textarea",
    "hiddenInput"
  ]
  static values = {
    msgAlertEmpty: { type: String, default: "암송할 내용을 입력해주세요." }
  }

  connect() {
    console.log("[InputMode] Controller connected")
    this.currentMode = "typing" // Default to typing mode
    this.updateUI()

    // Add form submit handler
    this.element.addEventListener("submit", (e) => this.handleSubmit(e))
  }

  handleSubmit(event) {
    this.syncHiddenInput()

    // Validate that we have text
    if (!this.hiddenInputTarget.value.trim()) {
      event.preventDefault()
      alert(this.msgAlertEmptyValue)
      return false
    }

    console.log("[InputMode] Form submitting with text:", this.hiddenInputTarget.value)
  }

  selectTyping() {
    console.log("[InputMode] Switching to typing mode")
    this.currentMode = "typing"
    this.updateUI()
  }

  selectVoice() {
    console.log("[InputMode] Switching to voice mode")
    this.currentMode = "voice"
    this.updateUI()
  }

  selectWordOrder() {
    console.log("[InputMode] Switching to word order mode")
    this.currentMode = "wordOrder"
    this.updateUI()
  }

  updateUI() {
    const modes = ["typing", "voice", "wordOrder"]
    const btnTargets = {
      typing: this.hasTypingBtnTarget ? this.typingBtnTarget : null,
      voice: this.hasVoiceBtnTarget ? this.voiceBtnTarget : null,
      wordOrder: this.hasWordOrderBtnTarget ? this.wordOrderBtnTarget : null
    }
    const modeTargets = {
      typing: this.hasTypingModeTarget ? this.typingModeTarget : null,
      voice: this.hasVoiceModeTarget ? this.voiceModeTarget : null,
      wordOrder: this.hasWordOrderModeTarget ? this.wordOrderModeTarget : null
    }

    // Update all buttons and panels
    modes.forEach(mode => {
      const isActive = this.currentMode === mode
      const btn = btnTargets[mode]
      const panel = modeTargets[mode]

      // Update button styling using CSS classes
      if (btn) {
        if (isActive) {
          btn.classList.remove("inactive")
          btn.classList.add("active")
        } else {
          btn.classList.remove("active")
          btn.classList.add("inactive")
        }
      }

      // Show/hide panels
      if (panel) {
        panel.style.display = isActive ? "block" : "none"
      }
    })
  }

  // Called before form submission to sync the hidden input
  syncHiddenInput() {
    if (!this.hasHiddenInputTarget) return

    if (this.currentMode === "typing" && this.hasTextareaTarget) {
      this.hiddenInputTarget.value = this.textareaTarget.value
    } else if (this.currentMode === "voice") {
      // Get text from speech recognition controller's textarea
      const voiceTextarea = this.voiceModeTarget?.querySelector("[data-speech-recognition-target='textarea']")
      if (voiceTextarea) {
        this.hiddenInputTarget.value = voiceTextarea.value
      }
    } else if (this.currentMode === "wordOrder") {
      // Get text from word order controller's textarea
      const wordOrderTextarea = this.wordOrderModeTarget?.querySelector("[data-word-order-target='textarea']")
      if (wordOrderTextarea) {
        this.hiddenInputTarget.value = wordOrderTextarea.value
      }
    }

    console.log("[InputMode] Synced hidden input:", this.hiddenInputTarget.value)
  }
}
